<template>
  <div class="d-block">
    <HMModalHeader :title="$t('STUDIO.TITLE.EVENTS')" @close="$emit('close')" />
    <CompactEventsCalendar :studioURL="studioURL" :openInNewWindow="true" />
  </div>
</template>

<script>
import Vue from 'vue';
import CompactEventsCalendar from '@/web/components/events/CompactEventsCalendar';
import HMModalHeader from '@/web/components/common/HMModalHeader';
export default Vue.extend({
  name: 'CompactEventsCalendarModal',
  components: {
    CompactEventsCalendar,
    HMModalHeader,
  },
  props: {
    studioURL: {
      type: String,
    },
    openInNewWindow: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped></style>
